import React, { useState, useEffect } from 'react';
import dotPattern from '../../assets/images/dot-pattern.png';
import loginVideo from '../../assets/images/login.mp4';
import maxbountyLogoSquare from '../../assets/images/MaxBounty_Square.png';
import { Link } from 'react-router-dom';
import Loading from '../../component/UI/Loading/Loading';

function formatEpc(epc) {
  const n = parseFloat(epc, 10);
  if (Number.isFinite(n) && n > 0) return `$${n.toFixed(2)}`;
  return 'New';
}

function normalizeCdnUrl(input) {
  if (!input || typeof input !== 'string') return null;

  const resourcesRoot = (process.env.REACT_APP_RESOURCE_URI || '').replace(/\/$/, '');
  const cdnRoot = (process.env.REACT_APP_TRACKING_CDN_URL || '').replace(/\/$/, '');

  try {
    const u = new URL(input);
    const pathname = u.pathname || '';

    if (resourcesRoot && pathname.startsWith('/creative/')) {
      return `${resourcesRoot}${pathname}${u.search || ''}`;
    }
    if (cdnRoot && pathname.startsWith('/trk/cdn/')) {
      return `${cdnRoot}${pathname.replace(/^\/trk\/cdn/, '')}${u.search || ''}`;
    }

    return input;
  } catch {
    if (resourcesRoot && input.startsWith('/creative/')) return `${resourcesRoot}${input}`;
    if (cdnRoot && input.startsWith('/trk/cdn/')) return `${cdnRoot}${input.replace(/^\/trk\/cdn/, '')}`;
    return input;
  }
}

export default function CampaignHubDetails({ campaign_id }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [c, setC] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    setC(null);
    fetch(`${process.env.REACT_APP_API_URL}/campaignHub/${campaign_id}`, {
      method: 'GET',
      credentials: 'omit',
    })
      .then((res) => res.json().then((body) => ({ ok: res.ok, body })))
      .then(({ ok, body }) => {
        if (ok && body.success && body.campaign) {
          setC(body.campaign);
        } else {
          setError((body.errors && body.errors.message) || 'Campaign not found.');
        }
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || 'Connection error.');
        setLoading(false);
      });
  }, [campaign_id]);

  return (
    <section className="text-center d-flex" style={{ background: 'RGBA(0,0,0,0.9)' }}>
      
      {/* Background Video */}
      <div
        style={{
          backgroundImage: `URL(${dotPattern})`,
          backgroundRepeat: 'repeat',
          height: '100%',
          width: '100%',
          position: 'fixed',
          zIndex: '9',
        }}
      />
      <video autoPlay muted loop className="login-video">
        <source src={loginVideo} type="video/mp4" />
      </video>

      <div className="campaign-hub-detail-container" style={{ position: 'relative', zIndex: 10, width: '100%' }}>
        <div className="position-relative" style={{ marginTop: '-40px' }}>
          <div className="m-3 bg-white rounded overflow-hidden" style={{ border: '1px solid #ccc' }}>
            {loading ? (
              <p className="text-muted py-5 mb-0"><Loading /></p>
            ) : error ? (
              <div className="alert alert-danger m-3 text-left" role="alert">
                {error}
              </div>
            ) : (
              <>
                <div className="overflow-hidden w-100" style={{ maxHeight: '300px' }}>
                  {normalizeCdnUrl(c.preview) ? (
                    <img src={normalizeCdnUrl(c.preview)} alt="" className="w-100" />
                  ) : (
                    <div className="w-100 bg-light" style={{ height: '300px' }} />
                  )}
                </div>
                <div className="d-flex justify-content-between align-items-center border-top px-2 py-2 flex-wrap">
                  <p className="font-weight-bold m-0 p-0 text-left">{c.name}</p>
                  <div className="text-secondary small text-left text-md-right">
                    {c.main_category_name} — {c.subcategory_name}
                  </div>
                </div>
                <div className="mt-1 text-left">
                  <table className="table table-card mb-0">
                    <tbody>
                      <tr>
                        <td>Status</td>
                        <td>{c.status_label}</td>
                      </tr>
                      <tr>
                        <td>Countries allowed</td>
                        <td>
                          {c.ip_filtering_flag === 'Y' ? (
                            c.countries && c.countries.length > 0 ? (
                              <span>{c.countries.join(', ')}</span>
                            ) : (
                              <span className="text-muted">—</span>
                            )
                          ) : (
                            <span>Traffic allowed from all countries.</span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>EPC</td>
                        <td>{formatEpc(c.epc)}</td>
                      </tr>
                      <tr>
                        <td>Payout</td>
                        <td>{c.affiliate_rate_text}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="border-top px-3 py-3 small" dangerouslySetInnerHTML={{ __html: c.description || '' }} />
                  <div className="border-top p-4 text-center">
                    <div className="alert alert-info mb-0">
                      <Link to="/">Login</Link> or <Link to="/register">register</Link> to view more details and access
                      this campaign.
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
